export default __webpack_public_path__ + "static/media/image-16.b7dcf6d5.svg";